import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import Card from './partials/card';
import Gear from '../../partials/gear';
import { Link } from 'react-router';
import _ from 'lodash';

class QAS extends React.Component {
    state = {
        microTransac: false,
        qas: null
    }
    componentWillMount() {
        const { qas, qasActions } = this.props;
        if (!qas) this.setState({ microTransac: true }, () => {
            qasActions && qasActions.fetch();
        });
        else this.setState({ qas });
    }
    componentWillReceiveProps = nextProps => {
        const { qas } = nextProps;
        this.setState({ qas, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    render() {
        const { microTransac, qas = [] } = this.state;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/dashboard" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">Q{'&'}A</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={6} onLogout={this.logout} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix">
                        <Link to="/admin/qas/add">
                            <figure className="card p-4 margin-right d-flex flex-row justify-content-center pointer hover-red bg-warning">
                                <i className="fa fa-plus font-30 align-self-center white" />
                                <span className="align-self-center margin-left-half font-14 white">Add Q{'&'}A</span>
                            </figure>
                        </Link>
                        {qas && _.sortBy(qas, 'IdCategory').map((qa, index) => <Card qa={qa} key={index} index={index} qasCategories={this.props.qasCategories} />)}
                    </section>
                </div>
            </section>
        )
    }
}

export default QAS;



// WEBPACK FOOTER //
// ./src/components/private/qas/index.js